// Lokale label/description per MSI-sector. Slugs MOETEN matchen met
// `effect.sectors[]` in de meetstandaard-api response. Sectoren die niet in
// deze map staan krijgen slug-as-label fallback.
//
// Bron-slugs:
//   - meetstandaard-api: https://us-central1-meetstandaard-api.cloudfunctions.net/database
//     → uniek effect.sectors[] uit alle effecten
//   - SectorLabels in src/components/meetstandaard/EffectDatabaseItemsList.jsx
//
// Bij een nieuwe sector in de API: voeg hier label + description toe.

const SECTOR_INFO = {
    'arbeidsparticipatie': {
        label: 'Arbeidsparticipatie',
        description: 'Voor organisaties gericht op werk, re-integratie en arbeidsmarkttoeleiding.',
    },
    'gelijke-kansen': {
        label: 'Gelijke kansen',
        description: 'Onderwijs, jeugd, kansenongelijkheid en sociale mobiliteit.',
    },
    'energiearmoede': {
        label: 'Energiearmoede',
        description: 'Wijkgerichte energie- en woonlastenprogramma\'s.',
    },
    'wijkbedrijven': {
        label: 'Wijkbedrijven',
        description: 'Bewonersbedrijven en wijkondernemingen: ontmoeting, leer-werktrajecten en buurtverbetering.',
    },
}

// Geeft de UI-info voor een sector-slug.
// Onbekende slugs krijgen { label: <slug>, description: '' } zodat ze nog steeds
// te selecteren zijn — de sector-catalog kan achterlopen op de api.
const getSectorInfo = (slug) => {
    if (SECTOR_INFO[slug]) return SECTOR_INFO[slug]
    return { label: slug, description: '' }
}

export { SECTOR_INFO, getSectorInfo }
